/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateOrderbookOptions,
  CreateOrderbookStatus201,
  CreateOrderbookStatus400,
  CreateOrderbookStatus500,
} from '../types/CreateOrderbook'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createOrderbook } from '../clients/createOrderbook'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createOrderbookMutationKey = () => [{ url: '/v1/orderbooks' }] as const

export function createOrderbookMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createOrderbookMutationKey()
  return mutationOptions<
    CreateOrderbookStatus201,
    ResponseErrorConfig<CreateOrderbookStatus400 | CreateOrderbookStatus500>,
    CreateOrderbookOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createOrderbook({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a new orderbook
 * {@link /v1/orderbooks}
 */
export function useCreateOrderbook<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateOrderbookStatus201,
      ResponseErrorConfig<CreateOrderbookStatus400 | CreateOrderbookStatus500>,
      CreateOrderbookOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createOrderbookMutationKey()

  const baseOptions = createOrderbookMutationOptions(config) as UseMutationOptions<
    CreateOrderbookStatus201,
    ResponseErrorConfig<CreateOrderbookStatus400 | CreateOrderbookStatus500>,
    CreateOrderbookOptions,
    TContext
  >

  return useMutation<
    CreateOrderbookStatus201,
    ResponseErrorConfig<CreateOrderbookStatus400 | CreateOrderbookStatus500>,
    CreateOrderbookOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateOrderbookStatus201,
    ResponseErrorConfig<CreateOrderbookStatus400 | CreateOrderbookStatus500>,
    CreateOrderbookOptions,
    TContext
  >
}
